<div style="position: relative; top: -35px; float: right; margin-bottom: 15px">
  <div style="display: inline-block; margin-right: 30px">
    <usimweb-input
      [(value)]="clearInput"
      [placeholder]="'Paste nozzle path here'"
      (paste)="paste($event)"
    ></usimweb-input>
  </div>

  <!-- <div style="display: inline-block">
    <usimweb-button-icon [icon]="'file_copy'"  fontColor="white" tooltip="Copy 4 to clipboard" (btnClick)="copy()"></usimweb-button-icon>
  </div>
</div>

<usimweb-table
  [data]="dataTableSource"
  [columns]="curveColumns"
  [filter]="filter"
  (clickedRow)="save($event)"
></usimweb-table>

<table aria-label="openMoldTable" mat-table [dataSource]="dataTableSource" class="mat-elevation-z8">
  <ng-container matColumnDef="index">
    <th mat-header-cell *matHeaderCellDef>Index</th>
    <td mat-cell *matCellDef="let model">{{ model.index }}</td>
  </ng-container>

  <ng-container matColumnDef="point">
    <th mat-header-cell *matHeaderCellDef>Point</th>
    <td mat-cell *matCellDef="let model">
      <usimweb-form-input
        placeholder="Point"
        style="width: 250px; display: inline-block"
        (selectionChange)="model.strPosition = $event"
        [value]="model.strPosition"
        name="point"
      ></usimweb-form-input>
    </td>
  </ng-container>

  <ng-container matColumnDef="orientation">
    <th mat-header-cell *matHeaderCellDef>Orientation</th>
    <td mat-cell *matCellDef="let model">
      <usimweb-form-input
        placeholder="Normal"
        style="width: 250px; display: inline-block"
        (selectionChange)="(model.strOrientation)"
        [value]="model.strOrientation"
        name="normal"
      ></usimweb-form-input>
    </td>
  </ng-container>

  <ng-container matColumnDef="timestep">
    <th mat-header-cell *matHeaderCellDef>Timestep</th>
    <td mat-cell *matCellDef="let model; let i = index">
      <div *ngIf="i == 0">0</div>

      <div *ngIf="i > 0 && i < tableSize">
        <usimweb-form-input
          placeholder="Timestep"
          style="width: 150px; display: inline-block"
          (selectionChange)="updateTime($event, i)"
          (selectionChange)="(model.timestep)"
          [value]="model.timestep"
          name="timestep"
        ></usimweb-form-input>
      </div>

      <div *ngIf="i === tableSize">
        {{ injectionTime }}
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="time">
    <th mat-header-cell *matHeaderCellDef>Time</th>
    <td mat-cell *matCellDef="let model">{{ model.time }}</td>
  </ng-container>

  <ng-container matColumnDef="delete">
    <th mat-header-cell *matHeaderCellDef>Selection</th>
    <td mat-cell *matCellDef="let model; let i = index">
      <usimweb-button-icon
        [icon]="'delete'"
         fontColor="white"
        (btnClick)="deletePointInfo(i)"
        color="red"
        tooltip="Delete a point..."
      ></usimweb-button-icon>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="curveColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: curveColumns"></tr>
</table>

<usimweb-paginator (changedPage)="onPaginateChange($event)" [pageSizeOptions]="[10, 20, 50]"></usimweb-paginator> -->
</div>
